<template>
	<div class="box">
		<div class="row">
			<div class="col-12">
				<LoadingSpinner v-if="loading" />

				<table v-else class="table table-hover table-sm mb-0">
					<thead class="sticky">
						<tr>
							<th class="w-50">{{ $t('monte.semence.norme') }}</th>
							<th class="w-25">{{ $t('monte.semence.stock') }}</th>
							<th class="w-25">{{ $t('monte.semence.stock_theorique') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="w-50">{{ $t('global.total') }}</td>
							<td class="w-25">{{ stocks.total.nb_stock }}</td>
							<td class="w-25">{{ stocks.total.nb_theorique }}</td>
						</tr>
						<template v-for="norme in stocks.normes">
							<tr v-if="norme.nb_stock > 0 || norme.nb_theorique > 0" :key="norme.protocole_id">
								<td class="w-50">{{ norme.protocole_label }}</td>
								<td class="w-25">{{ norme.nb_stock }}</td>
								<td class="w-25">{{ norme.nb_theorique }}</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Semence from "@/mixins/Semence.js"

	export default {
		name: 'StallionStocks',
		mixins: [Semence],
		props: ['horse_id'],
		data () {
			return {
				loading: true,
				stocks: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				this.stocks = await this.getStockStallion(this.horse_id)
				this.loading = false
			},
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		}
	}

</script>